

import React, { useState, useEffect } from 'react';
import KinosLeadModal from "./KinosLeadModal";
import WhatsAppHeroVisual from "./WhatsAppHeroVisual";
import WhatsAppHeroVisualMobile from "./WhatsAppHeroVisualMobile";

const HeroSection = ({ onOpenDemo }) => {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="relative bg-white overflow-x-visible sm:overflow-x-hidden overflow-y-visible text-gray-800 mb-0 min-h-[60vh] md:min-h-[80vh]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 h-full flex items-center pt-12 md:pt-20 pb-8 md:pb-16">
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 xl:gap-16 items-center">
          {/* Left: copy & CTAs */}
          <div className="text-center lg:text-left space-y-3 md:space-y-6 lg:pr-4 order-1">
            <div className="space-y-2 md:space-y-4">
              <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-black/80 mb-1 md:mb-2 text-center lg:text-left">
                ai revenue operator for smbs
              </p>
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-[3.25rem] xl:text-6xl font-bold tracking-tight text-black leading-[1.08]">
                Find the ad dollars you are wasting.
                <br />
                Before you spend them again.
              </h1>

              <p className="text-base sm:text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto lg:mx-0 pt-1">
                Connect your commerce stack and Meta/Google. Kolanut scans your last 30 days and shows you exactly which
                campaigns are losing money.
              </p>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto lg:mx-0">
                No auto-execution. No risk. Just a report you can act on.
              </p>
            </div>

            <div className="space-y-0 sm:space-y-3 md:space-y-5 flex flex-col items-center lg:items-start pt-0 sm:pt-1">
              <div className="flex items-center justify-center lg:justify-start w-full sm:w-auto">
                <a
                  href="https://engagement.kolanut.ai/signup"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hidden sm:inline-flex items-center justify-center gap-2 h-12 md:h-14 px-8 md:px-10 lg:px-14 rounded-full bg-[#8ae690] text-black font-semibold text-sm md:text-base shadow-md hover:bg-[#7ad67f] hover:shadow-lg transition-all duration-200 w-full sm:w-auto"
                >
                  <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white/70">
                    <img
                      src="/kolanut_logo.png"
                      alt="Kolanut logo"
                      className="w-4 h-4 object-contain"
                    />
                  </span>
                  Try Kolanut now
                </a>
              </div>

              <div className="flex flex-col gap-2 w-full">
                <div className="flex flex-col items-center sm:flex-row sm:items-center gap-3">
                  <div className="flex -space-x-2 sm:-space-x-3 shrink-0">
                    {['/avatar7.png', '/avatar8.png', '/avatar9.png', '/avatar10.png'].map((src, i) => (
                      <img
                        key={i}
                        src={src}
                        alt=""
                        className="w-6 h-6 sm:w-10 sm:h-10 rounded-full border-2 border-white object-cover shadow-sm"
                      />
                    ))}
                  </div>
                  {/* <p className="text-base sm:text-lg text-gray-600 leading-relaxed text-center sm:text-left">
                    Join other happy businesses and agencies.
                  </p> */}
                </div>
                <p className="text-xs sm:text-sm text-black/70 text-center sm:text-left leading-snug px-1 sm:px-0">
                  {/* Free during early access. No credit card required */}
                  Join other happy businesses and agencies.

                </p>
              </div>
            </div>
          </div>

          {/* Right: phone + floats — full viewport width on mobile so 100vw math matches layout (prevents side clipping) */}
          <div className="relative order-2 flex flex-col items-center overflow-visible w-full max-sm:ml-[calc(50%-50vw)] max-sm:w-screen max-sm:max-w-[100vw] max-sm:mx-0 sm:mx-auto sm:max-w-lg lg:max-w-none lg:mx-0">
            <div className="block w-full sm:hidden">
              <WhatsAppHeroVisualMobile />
            </div>
            <div className="hidden w-full sm:block">
              <WhatsAppHeroVisual />
            </div>
            <p className="mt-4 text-center text-[10px] text-gray-400 max-w-xs sm:max-w-none px-4 sm:px-0">
              Connects to the same integrations as below: Shopify, Square, Meta, Google Ads, Boulevard, and more.
            </p>
          </div>
        </div>
      </div>

      {!onOpenDemo ? (
        <KinosLeadModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          email=""
        />
      ) : null}
    </section>
  );
};

export default HeroSection;
